import React, { useContext, useEffect, useState } from "react";
import { Box, Heading, Tabs, TabList, TabPanels, Tab, TabPanel, Table, Thead, Tbody, Tr, Th, Td, Spinner, HStack, VStack, Input, Button, useToast, Select, Badge } from "@chakra-ui/react";
import { Navigate } from "react-router-dom";
import AuthContext from "../../../contexts/Auth";
import client from "../../../helpers/Client";
import Pagination from "../../../components/pagination/Pagination";
import urlToId from "../../../helpers/UrlToId";

function LogTable({ title, path, actorFilter, kindFilter, subjectFilter }) {
  const toast = useToast();
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [numOfPages, setNumOfPages] = useState(1);
  const [numOfItems, setNumOfItems] = useState(0);

  const fetchLogs = async (page = 1) => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.set("page", page);
      if (actorFilter) params.set("actor", actorFilter);
      if (kindFilter) params.set("kind", kindFilter);
      if (subjectFilter) params.set("subject", subjectFilter);
      const { data } = await client.get(`${path}?${params.toString()}`);
      const results = data.results || data;
      setItems(results);
      setNumOfPages(data.num_of_pages || data.total_pages || 1);
      setNumOfItems(data.num_of_items || data.count || results.length || 0);
      setCurrentPage(data.current_page || page);
    } catch (e) {
      toast({ title: `${title} alınamadı`, status: "error" });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actorFilter, kindFilter, subjectFilter]);

  return (
    <Box>
      {loading ? (
        <Spinner />
      ) : (
        <Table size="sm" variant="simple">
          <Thead>
            <Tr>
              <Th>Tür</Th>
              <Th>Aktör</Th>
              <Th>Konu</Th>
              <Th>Tarih</Th>
            </Tr>
          </Thead>
          <Tbody>
            {items.map((i) => (
              <Tr key={i.url || `${i.kind}-${i.created_at}-${i.actor?.url || Math.random()}`}>
                <Td><Badge colorScheme="blue">{i.kind}</Badge></Td>
                <Td>{i.actor ? `${i.actor.first_name} ${i.actor.last_name}` : '-'}</Td>
                <Td>{i.subject || '-'}</Td>
                <Td>{i.created_at}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      )}
      <Box mt={4}>
        <Pagination path={"admin/loglar"} num_of_items={numOfItems} num_of_pages={numOfPages} currentPage={currentPage} onPageChange={(p) => fetchLogs(p)} />
      </Box>
    </Box>
  );
}

export default function AdminLogs() {
  const auth = useContext(AuthContext);
  const isSuperUser = auth.data?.user?.is_superuser;

  const [actorFilter, setActorFilter] = useState("");
  const [kindFilter, setKindFilter] = useState("");
  const [subjectFilter, setSubjectFilter] = useState("");

  if (!isSuperUser) {
    return <Navigate to="/ana-sayfa/" replace />;
  }

  return (
    <Box p={6}>
      <Heading size="md" mb={4}>Hareket Logları</Heading>

      <VStack align="stretch" spacing={4} mb={4}>
        <HStack spacing={3}>
          <Input placeholder="Aktör ID" value={actorFilter} onChange={(e) => setActorFilter(e.target.value)} w="180px" />
          <Input placeholder="Konu ID" value={subjectFilter} onChange={(e) => setSubjectFilter(e.target.value)} w="180px" />
          <Select placeholder="Tür" value={kindFilter} onChange={(e) => setKindFilter(e.target.value)} w="200px">
            <option value="assigned">assigned</option>
            <option value="unassigned">unassigned</option>
            <option value="started">started</option>
            <option value="completed">completed</option>
            <option value="created">created</option>
            <option value="deleted">deleted</option>
            <option value="cancelled">cancelled</option>
            <option value="approved">approved</option>
          </Select>
          <Button colorScheme="blue" onClick={() => { /* trigger refresh via state change */ setKindFilter(kindFilter); }}>Filtrele</Button>
        </HStack>
      </VStack>

      <Tabs variant="enclosed" colorScheme="blue">
        <TabList>
          <Tab>Ticket Logları</Tab>
          <Tab>Görev Logları</Tab>
          <Tab>Servis Kayıt Logları</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <LogTable title="Ticket Logları" path="/logs/tickets/" actorFilter={actorFilter} kindFilter={kindFilter} subjectFilter={subjectFilter} />
          </TabPanel>
          <TabPanel>
            <LogTable title="Görev Logları" path="/logs/tasks/" actorFilter={actorFilter} kindFilter={kindFilter} subjectFilter={subjectFilter} />
          </TabPanel>
          <TabPanel>
            <LogTable title="Servis Kayıt Logları" path="/logs/service_records/" actorFilter={actorFilter} kindFilter={kindFilter} subjectFilter={subjectFilter} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
}